<template>
  <div class="table-price-list" :style="{left:locationleft+'px'}" v-if="visible" v-clickoutside:[classList]="closeIconBlock">
    <a-spin :spinning="$store.state.tabLoding">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" />
      <a-row v-for="(item,index) in priceList" :key="index">
        <a-col @click="btnSelectPrice(item)">
          {{ item.showName+'：'+item.price }}
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>
<script>
import { getPriceList } from "@/utils/api"
export default {
  data () {
    return {
      visible: false,
      classList: [],
      num: 0,
      index: null,
      priceList: [],
      spinning: false
    }
  },
  props: {
    locationleft: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    open (record, index) {
      setTimeout(function () {
        this.num += 1
      }, 200);
      this.index = index
      this.visible = true
      this.$store.state.tabLoding = true
      this.getPriceList(record)
    },
    cancel () {
      this.num = 0;
      this.visible = false;
      this.$emit("cancel", this.index)
    },
    getPriceList (record) {
      let data = {
        productId: record.productId
      }
      let params = {}
      getPriceList(params, {}, data).then((res) => {
        if (res.code == 200) {
          this.$store.state.tabLoding = false
          this.priceList = JSON.parse(res.result.presetPriceJson)
        } else {
          this.$message.error(res.logMessage)
        }
      })
    },
    closeIconBlock () {
      if (this.num == 1) {
        this.cancel()
      }
    },
    btnSelectPrice (item) {
      item.index = this.index
      this.$emit('btnSelectPrice', item)
      this.cancel()
    }
  },
};
</script>
<style lang="scss">
.table-price-list {
  position: absolute;
  top: 40;
  left: 0px;
  width: 150px;
  z-index: 1030;
  background-color: #fff;
  box-shadow: 0px 1px 14px 0px rgba(1, 85, 255, 0.16);
  padding: 12px 0;
  min-height: 100px;
  .ant-row {
    padding: 8px 0;
    text-align: center;
    cursor: pointer;
  }
  .ant-row:hover {
    background-color: #fafafa;
    color: #387bfc;
  }
}
</style>
